import styles from '../pageLayout.module.css';

export default function DefaultFooter({ buttonArray }) {
	return (
		<div className={styles.defaultFooterRoot}>
			<div className={styles.defaultFooterContent}>{buttonArray}</div>
		</div>
	);
}
